import { Box, Typography } from '@mui/material';

function DeliveryAreaSection({
  locationName,
  nearbyCities,
  deliveryRadiusKm,
  industryTags,
}) {
  const cities = (nearbyCities ?? []).slice(0, 5);
  const tags = industryTags ?? [];

  if (!cities.length && !tags.length) return null;

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      {cities.length > 0 && (
        <>
          <Typography variant="subtitle2" color="primary.dark" sx={{ mb: 0.5 }}>
            Liefergebiet ab {locationName}
            {deliveryRadiusKm ? ` (${deliveryRadiusKm} km)` : ''}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {cities.map((city, i) => (
              <span key={city.name}>
                {city.name}
                <Typography
                  variant="caption"
                  component="span"
                  color="text.disabled"
                  sx={{ ml: 0.25 }}>
                  ({Math.round(city.distanceKm)}&thinsp;km)
                </Typography>
                {i < cities.length - 1 ? ' · ' : ''}
              </span>
            ))}
          </Typography>
        </>
      )}
      {tags.length > 0 && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: cities.length > 0 ? 1 : 0 }}>
          {tags.join(' · ')}
        </Typography>
      )}
    </Box>
  );
}

export default DeliveryAreaSection;
